import type { ComponentType } from "react";
import type { IconProps } from "@phosphor-icons/react";
import {
  MapTrifold,
  Ruler,
  SquaresFourIcon,
  Target
} from "@phosphor-icons/react";

export const defaultIconProps: Pick<IconProps, "size" | "weight"> = {
  size: 18,
  weight: "bold"
};

export type IconComponent = ComponentType<IconProps>;

export type IconLibraryKey =
  | "lotsActive"
  | "lotsArea"
  | "lotsTraverse"
  | "lotsClosure";

export const iconLibrary: Record<IconLibraryKey, IconComponent> = {
  lotsActive: SquaresFourIcon,
  lotsArea: MapTrifold,
  lotsTraverse: Ruler,
  lotsClosure: Target
};

export const summaryIconProps: IconProps = {
  size: 28,
  weight: "fill"
};
